// extracted by mini-css-extract-plugin
export default {"screen":"LoadingScreen_screen__GYhWR","content":"LoadingScreen_content__iikyG","spinner":"LoadingScreen_spinner__fESbr","text":"LoadingScreen_text__v-CoZ"};